export function normalizeBarcode(value?: string | null) {
  return String(value || '')
    .replace(/[\u0000-\u001F\u007F]/g, '')
    .replace(/^\][A-Za-z0-9]{2}/, '')
    .trim()
}

export function compactBarcode(value?: string | null) {
  return normalizeBarcode(value).toLowerCase().replace(/[\s-]/g, '')
}
